angular.module("survey").directive("expressLaneButtons", ["queryParser", "$window", expressLaneButtons])

function expressLaneButtons(queryParser, $window) {
  let queryAmounts = queryParser($window.location.search).amounts;
  if (queryAmounts) {
    queryAmounts = queryAmounts.split(",").map(Number).filter(i => !Number.isNaN(i) && i > 0);
  }
  
  return {
    restrict: "E",
    controllerAs: "btns",
    template: `<div class="express-lane-buttons-container">
      <express-lane-button ng-repeat="amt in btns.amounts" ng-style="{'width': btns.width, 'visibility': btns.visibility}" class="express-lane-button-container"></express-lane-button>
    </div>`,
    controller: ["$scope", "$element", function($scope, $element) {
      const btns = this;
      
      if (queryAmounts && queryAmounts.length) {
        btns.amounts = [...queryAmounts, "Other"];
      } else {
        btns.amounts = $scope.question.express_lane_amounts;
      }

      // hide buttons until we have determined how large they should be
      btns.visibility = "hidden";
      $scope.$applyAsync(() => {
        // match all button widths to largest button
        var largestWidth = 0;
        const containers = $element.children().eq(0).children();
        for (var i = 0; i < containers.length; i++) {
          const width = containers[i].children[0].getBoundingClientRect().width;
          if (width > largestWidth) largestWidth = width;
        }
        btns.width = largestWidth + "px";
        btns.visibility = "visible";
      })
    }]
  }
}